<template lang="pug">
AppDialog.vue-invites-onboarding-status-dialog(
  title="Team onboarding"
  append-to-body
  :show="show"
  @close="close"
)
  .row
    .col-xs-12
      .row
        .tip.col-sm-8
          span See the progress of members invited via email and send reminders to help them get fully onboarded.
        .col-sm-4
          AppOnOffToggle.mt-10(v-model="showCompletedMembers")
            | show onboarded members
  .row
    .col-xs-12
      InvitesOnboardingStatusTable.hidden-xs(
        :invites="filteredInvites"
        :organization-id="organizationId"
        :loading="loading"
        :is-loading-more="isLoadingMore"
      )
      AppScrollableTable(:has-fixed-column="false")
        InvitesOnboardingStatusTable(
          :invites="filteredInvites"
          :organization-id="organizationId"
          :loading="loading"
          :is-loading-more="isLoadingMore"
        )
  .row
    .col-xs-12
      .tip
        i.hi.hi-info.hi-14.pr-5
        span(v-if="isFieldGroup")
          span
            |
            | In order to track your crew’s location, you must have their
          span
            |
            a(:href="settingsUrl")
              |
              | location settings
          span
            |
            | enabled, and they must allow location tracking when installing the mobile app.
        span(v-else)
          span Team members can currently track time in several ways. You can adjust their
          span
            a(:href="settingsUrl")
              |
              | timer app settings
          span
            |
            | if you’d like to record screenshots and activity (desktop app only).
  template(slot="footer")
    button.btn.btn-default(
      ref="footer"
      @click="close"
    ) Close
</template>

<script>
import { isEmpty } from 'lodash-es';
import api from '~/api';
import InvitesOnboardingStatusTable from './InvitesOnboardingStatusTable.vue';

export default {
  name: 'InvitesOnboardingStatusDialog',
  components: {
    InvitesOnboardingStatusTable,
  },
  props: {
    organizationId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      show: false,
      loading: true,
      isFieldGroup: false,
      showCompletedMembers: true,
      settingsUrl: null,
      invites: [],
      currentPage: 1,
      totalPages: 1,
      isLoadingMore: false,
    };
  },
  computed: {
    filteredInvites() {
      return this.showCompletedMembers ? this.invites : this.invites.filter((i) => !this.isComplete(i));
    },
  },
  mounted() {
    const options = {
      root: null, // Use the viewport as the root
      rootMargin: '0px',
      threshold: 1.0, // Trigger when 100% of the target is visible
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadMoreInvites();
        }
      });
    }, options);

    observer.observe(this.$refs.footer);
  },
  methods: {
    error() {
      this.$appMessage('Something went wrong. Please try again.');
    },
    isComplete(invite) {
      return invite.accepted && invite.has_downloaded_client && invite.has_client_activity;
    },
    open() {
      this.show = true;
      if (isEmpty(this.invites)) {
        this.currentPage = 1;
        this.loadInvites();
      }
    },
    close() {
      this.show = false;
    },
    loadInvites() {
      this.loading = true;
      const success = (response) => {
        this.invites = response.invites;
        this.isFieldGroup = response.is_field_group;
        this.settingsUrl = response.settings_url;
        this.totalPages = response.total_pages;
        this.loading = false;
      };

      api
        .get(`/organizations/${this.organizationId}/invites/onboarding_status?page=${this.currentPage}`)
        .then(success, this.error);
    },
    loadMoreInvites() {
      if (this.isLoadingMore || this.currentPage >= this.totalPages) {
        return;
      }
      this.isLoadingMore = true;
      const success = (response) => {
        this.invites = [...this.invites, ...response.invites];
        this.currentPage += 1;
        this.isLoadingMore = false;
      };

      api
        .get(`/organizations/${this.organizationId}/invites/onboarding_status?page=${this.currentPage + 1}`)
        .then(success, this.error);
    },
  },
};
</script>
